import React from 'react';
import logo from '../Header/logo.png';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { instance } = useMsal();
    const isLoginPage = location.pathname === '/';
    const environment = process.env.REACT_APP_ENV || 'dev';

    const handleLogout = async () => {
        sessionStorage.removeItem('sessionStartTime');

        // Check if user is authenticated via MSAL (Microsoft)
        const accounts = instance.getAllAccounts();

        if (accounts && accounts.length > 0) {
            // Microsoft session logout - clear cache only (no redirect to Microsoft)
            // This keeps users logged into their other Microsoft accounts
            const account = accounts[0];
            await instance.clearCache({ account });
            window.location.replace("/");
        } 
    };

    return (
        <header className="main-header">
            <div className="logo">
                <div className='sol-logo'>
                    <img src={logo} alt="Logo" />
                </div>
                <span className="logo-text">Solifi</span>
                <span className="logo-subtext">Knowledge Assistant{environment !== 'prod' ? ` - ${environment.toUpperCase()}` : ''}</span>
            </div>

            <div>
                {!isLoginPage && (<button
                    className="profile-btn"
                    onClick={() => navigate('/profile')}
                >
                    <span>Profile</span>
                </button>)}

                {/* Only show logout button when authenticated */}
                {!isLoginPage && (
                    <button className="logout-btn" onClick={handleLogout}>
                        Logout
                    </button>
                )}
            </div>
        </header>
    );
};

export default Header;